import { emptyGridImg } from 'utils/helpers';
import { IS_CAMPER } from 'utils/constants/system';

import styles from './style.module.css';

export default function ProductPlaceholder({ square = false }: { square?: boolean }) {
  const camperImage = square ? '/assets-new/loading-square.png' : '/assets-new/loading-new.png';
  return (
    <div className={styles.gridItem}>
      <div className={styles.gridPhoto}>
        <img src={IS_CAMPER ? camperImage : emptyGridImg} className={styles.image} alt="" />
      </div>
      {!IS_CAMPER && <div className={styles.gridContent} />}
    </div>
  );
}
